import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
import { X } from "lucide-react"; // Importing close icon

const DeclinePopup = ({ isOpen, onClose, awbNumber, setRefresh }) => {
    const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

    const [text, setText] = useState("");
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const [session, token] = document.cookie.split("=");
            const payload = { awbNumber, text };
            // console.log(payload)

            const response = await axios.post(
                `${REACT_APP_BACKEND_URL}/dispreancy/declineDiscrepancy/`,
                payload,
                {
                    headers: {
                        authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log(response)
            toast.success(response.data.message);
            setRefresh((prev) => !prev);
            onClose();
        } catch (err) {
            toast.warn(err.response?.data?.message || "Something went Wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-[600px] text-center relative">
                {/* Close Button */}
                <button
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                    onClick={onClose}
                >
                    <X size={24} />
                </button>

                <p className="mb-2 text-gray-700">
                    AWB Number: <strong>{awbNumber}</strong>
                </p>

                <h2 className="text-lg font-semibold mb-4">Declined Reason</h2>
                <textarea
                    className="w-full border rounded p-2 focus:outline-none focus:ring focus:ring-blue-300"
                    placeholder="Enter text..."
                    rows="4"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                ></textarea>

                <div className="flex justify-end mt-4 gap-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-500 text-white rounded"
                    >
                        Close
                    </button>
                    <button
                        className={`px-4 py-2 rounded-md text-white ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-[#0CBB7D]"
                            }`}
                        onClick={handleConfirm}
                        disabled={loading} // Disable button when loading
                    >
                        {loading ? "Processing..." : "Submit"} {/* Show loading text */}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeclinePopup;
